import {useQuery} from "@tanstack/react-query"
import {head} from "lodash"
import {generalSettingsService} from "services"
import {YesNo} from "types/common"
import {GeneralSettingField} from "types/settings/general-setting"

export const useAttendanceCheckBreakEventSetting = () => {
    const {data: settings} = useQuery(
        ["attendance-check-break-event-setting"],
        () => generalSettingsService.getSettings([GeneralSettingField.AttendanceCheckBreakEvent]),
        {initialData: []}
    )
    const isBreakEnabled = head(settings)?.value === YesNo.Yes

    return {isBreakEnabled}
}
